export default __webpack_public_path__ + "static/media/zoom.568bda3e.svg";